import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, NgForm } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location, DatePipe } from '@angular/common';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from '@danielmoncada/angular-datetime-picker';

import { MomentDateTimeAdapter } from '@danielmoncada/angular-datetime-picker-moment-adapter';
import * as moment from "moment"
import { AlertController, ModalController } from '@ionic/angular';


export const MY_CUSTOM_FORMATS = {
  parseInput: 'LL LT',
  fullPickerInput: 'DD-MM-YYYY HH:mm',
  datePickerInput: 'DD-MM-YYYY',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@Component({
  selector: 'app-question-of-the-week-detail',
  templateUrl: './question-of-the-week-detail.page.html',
  styleUrls: ['./question-of-the-week-detail.page.scss'],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS },
  ],
})
export class QuestionOfTheWeekDetailPage implements OnInit {
  @ViewChild('f', { read: NgForm }) form: any;

  questions: any = {};
  QuestionOfTheWeekId: any = '';
  categories = [];
  showPage: boolean = false;
  locale: any = '';
  submitted: boolean = false;
  selectImageFile: boolean = false;


  constructor(private formBuilder: FormBuilder,
    private location: Location,
    private _apiService: ApiService,
    public _commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private el: ElementRef,
    private alertController: AlertController,
    private dateTimeAdapter: DateTimeAdapter<any>,
    private datePipe: DatePipe) { }

  ngOnInit() {
  }
  ionViewWillEnter() {
    this.form.reset();
    this.submitted = false;
    this.selectImageFile = false;
    this.locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
    this.QuestionOfTheWeekId = this.route.snapshot.paramMap.get('id');
    if (this.QuestionOfTheWeekId == '0') {
      this.QuestionOfTheWeekId = null;
    }
    this.getCategories();
    this.showPage = true;
       if (this.QuestionOfTheWeekId) {
      this.getQuestionDetails();
    }else{
      this.questions = {
        Description: '',
        CategoryId: '',
        DateVisibleFrom: '',
        Image: null,
        ImageName: ''
      }

    }
  }

  async getCategories() {
    let res = await this._apiService.getCategories('', '', '', 1, 0);
    this.categories = res.body
  }

  async getQuestionDetails() {
    this._commonService.presentLoading();
    try {
      let res = await this._apiService.getQuestionOfTheWeekDetail(this.QuestionOfTheWeekId);
      this.questions = res.body;
      this._commonService.log(this.questions, this._commonService.LOG);
      this._commonService.dismiss();
      this.showPage = true
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR)
    }
  }

  async onSubmit(f) {
    this.submitted = true
    if(this.questions.Image == null || this.questions.Image == ""){
      // const image = f.form.get('Image');
      // image.setErrors(null);
      return;
    }
    // console.log('f.form', f.form);
    if (f.form.invalid) {
      return
    }
    this._commonService.presentLoading()
    try {
      let data = {
        "Description": this.questions.Description || null,
        "CategoryId": this.questions.CategoryId || null,
        // "DateVisibleFrom": this.questions.DateVisibleFrom || null,
        "DateVisibleFrom": this.datePipe.transform(new Date(this.questions.DateVisibleFrom)),
        "Image": this.questions.Image ? this.questions.Image.replace(/^data:image\/[a-z]+;base64,/, "") : null,
        "ImageName": this.questions.ImageName || null
      }
      // let formData = new FormData();
      // formData.append('Description', this.questions.Description||null);
      // formData.append('CategoryId', this.questions.CategoryId||null);
      // formData.append('DateVisibleFrom', this.datePipe.transform(this.questions.DateVisibleFrom, 'yyyy-MM-dd'));
      // formData.append('Image', this.selectImageFile ? this.questions.Image||"" : "");
      if (!this.QuestionOfTheWeekId) {
        let res = await this._apiService.postQuestionOfTheWeekDetail(data);
        if(res){
          this.QuestionOfTheWeekId = res.QuestionOfTheWeekId;
            this.location.replaceState('maintenance/questionoftheweek/' + this.QuestionOfTheWeekId);
          }
      } else {
        let res = await this._apiService.putQuestionOfTheWeekDetail(data, this.QuestionOfTheWeekId);
      }
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
      this._commonService.log(data, this._commonService.LOG);
      this._commonService.dismiss();
      this.submitted = false;
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR)
    }


  }

  delete() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          await this._apiService.deleteQuestionOfTheWeekDetail(this.QuestionOfTheWeekId);
          this._commonService.dismiss();
          this._commonService.log(res, this._commonService.LOG);
          this.goBack();
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }

  goBack() {
    this.router.navigate(['maintenance/questionoftheweek'])
  }

  onCategoryChanged(event) {
    this.questions.Category = event
  }



  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
        this.onSubmit(this.form);
        break;
      case "delete":
        this.delete();
        break;
      case "backToList":
        this.goBack();
        break;
      case "backToMain":
        this.router.navigate(['maintenance'], { replaceUrl: true })
        break;
      case "back":
        this.goBack();
        break;
    }

  }
//   DateTimeChange(event) {
//     this.form.control.setValue({
//       Date: this.datePipe.transform(new Date(event.value), "dd-MM-yyyy"),
//     })
// // this.questions.DateVisibleFrom = this.datePipe.transform(new Date(event.value), "dd-MM-yyyy");
//   }



  onSelectFile(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      this.questions.ImageName = event.srcElement.files[0].name ? event.srcElement.files[0].name : null;
      reader.onload = (event: any) => {
        // called once readAsDataURL is completed
        this.questions.Image = event.target.result.replace(/^data:image\/[a-z]+;base64,/, "");
      }
    }
  }
  // async onSelectFile(files: any) {
  //   let items: any = [];
  //   try {
  //     if (files.length ) {

  //       let fileName = files[0].name;
  //       this.questions.Image = files[0];
  //       let ext = null;
  //       // this.docxName = fileName;
  //       // this.standardForm.patchValue({
  //       //   DocumentFileNaame: fileName
  //       // });
  //       var reader = new FileReader();
  //           reader.readAsDataURL(files[0]); // read file as data url
  //           reader.onload = (event: any) => {
  //             // called once readAsDataURL is completed
  //             this.questions.ImagePath = event.target.result.replace(/^data:image\/[a-z]+;base64,/, "");
  //           }
  //           this.selectImageFile = true;
  //       this._commonService.dismiss();
  //     }
  //   } catch (error) {
  //     this._commonService.dismiss();
  //     this._commonService.log(error, this._commonService.ERROR);
  //   }
  //   // this.uploader.nativeElement.value = null;
  // }
  deleteImage() {
    if (this.questions.Image) {
      this.questions.Images = null;
      this.questions.Image = null;
    }
  }
}
